import axios from 'axios'
import { miniappSkins } from '@/config/miniappSkins'

export const ADMIN_SKIN_SAVED = 'admin-skin-saved'
export function resolveAdminSkin(value: unknown) {
  return miniappSkins.find(skin => skin.value === value) || miniappSkins[0]
}
export function readPublicSkin(data: any, orgId: number): string | undefined {
  if (Number(data?.orgInfo?.id) !== orgId) return undefined
  try {
    const settings = typeof data.orgInfo.settings === 'string' ? JSON.parse(data.orgInfo.settings) : data.orgInfo.settings
    return miniappSkins.some(skin => skin.value === settings?.miniappTheme) ? settings.miniappTheme : 'classic'
  } catch (_) { return undefined }
}
export function adminSkinRgb(value:unknown):string {
 const hex=String(value || '').replace(/^#/,'')
 if(!/^[0-9a-f]{6}$/i.test(hex))return '24,144,255'
 return [0,2,4].map(index=>parseInt(hex.slice(index,index+2),16)).join(',')
}
export function applyAdminSkin(value: unknown) {
  const skin = resolveAdminSkin(value)
  document.documentElement.dataset.adminSkin = skin.value
  document.documentElement.style.setProperty('--activeColorRGB',adminSkinRgb(skin.colors[0]))
  const names = ['--activeColor', '--admin-skin-deep', '--admin-skin-canvas', '--admin-skin-soft', '--admin-skin-surface']
  names.forEach((name, index) => document.documentElement.style.setProperty(name, skin.colors[index]))
}
// 只读取已有公开皮肤，不调用有编辑权限限制的设置接口，不触发登录拦截器。
export function createAdminSkinSync(load = async (orgId: number) => {
  const result = await axios.get('land/orgidid', { baseURL: process.env.VUE_APP_BASE_API, params: { orgId }, timeout: 8000 })
  if (!result.data?.success) throw new Error('Skin unavailable')
  return result.data.data
}, apply = applyAdminSkin) {
  let generation = 0, currentOrg = 0
  return {
    async refresh(orgId: number) {
      const revision = ++generation
      if (orgId !== currentOrg) { currentOrg = orgId; apply('classic') }
      try {
        const skin = readPublicSkin(await load(orgId), orgId)
        if (revision === generation && skin) apply(skin)
      } catch (_) { /* 同店弱网保留当前皮肤，切店失败使用默认皮肤。 */ }
    },
    dispose() { generation++ }
  }
}
